/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2024-05-20 09:30:53
 *
 *******************************************************/
// @flow

import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import AppInsightContainer from './app-insight';
import { ANALYTICS_ADDON_NAME } from 'src/constants/subscription';
import { getShop } from 'src/helpers';
import { getInitDate } from 'src/helpers/analytics-helpers';
import * as AnalyticsActions from 'src/stores/actions/analytics-v2-actions';
import * as subscriptionV3Actions from 'src/stores/actions/subscription-v3-actions';
import { FEATURES } from 'src/constants/analytics';

type Props = WithI18nProps;
type State = {
  actionSurvey: boolean,
  youtubeModal: boolean
};

const fromDateStateName = 'appInsightFromDate';
const toDateStateName = 'appInsightToDate';
const compareStateName = 'appInsightCompare';

class AppInsight extends Component<Props, State> {
  timeoutActionSurvey = undefined;
  templateKey = 'app-insight';
  state = {
    actionSurvey: false,

    youtubeModal: false,
    modalAddon: false
  };

  componentDidMount() {
    const { changeValue, getAddonStatus, getDetailInvoice, invoice, selectedPlan } = this.props;

    getAddonStatus(ANALYTICS_ADDON_NAME);
    // Get detail invoice
    if (_.isEmpty(invoice) || !invoice) {
      getDetailInvoice();
    }

    const { fromDate, toDate, compare } = getInitDate(FEATURES.APP_IMPACT, this.templateKey, selectedPlan);

    changeValue(fromDateStateName, fromDate);
    changeValue(toDateStateName, toDate);
    changeValue(compareStateName, compare);

    // Handle when reload or leave page
    window.addEventListener('beforeunload', this.handleLeavePage);
  }

  componentWillUnmount() {
    this.handleLeavePage();

    // Handle when reload or leave page
    window.removeEventListener('beforeunload', this.handleLeavePage);
  }

  handleLeavePage = () => {
    // Insert data to local storage
    try {
      const { fromDate, toDate, compare = false } = this.props;
      localStorage.setItem(`${getShop()}-${this.templateKey}-fromDate`, fromDate.toISOString());
      localStorage.setItem(`${getShop()}-${this.templateKey}-toDate`, toDate.toISOString());
      localStorage.setItem(`${getShop()}-${this.templateKey}-compare`, compare.toString());
    } catch (error) {}
  };

  render() {
    return (
      <AppInsightContainer
        performActionSurvey={this.performActionSurvey}
        openReviewAddonModal={() => this.toggleModal('modalAddon')}
      />
    );
  }

  // Run survey when user perform action: change tab, view detail, change date and scroll
  performActionSurvey = () => {
    const { actionSurvey } = this.state;

    clearTimeout(this.timeoutActionSurvey);

    this.timeoutActionSurvey = setTimeout(() => {
      this.setState({ actionSurvey: !actionSurvey });
    }, 30000);
  };

  // Handle scroll action
  handleScroll = e => {
    this.performActionSurvey();
  };

  toggleModal = fieldName => {
    const value = this.state[fieldName];
    this.setState({ [fieldName]: !value });
  };

  // Auto reload page
  handleCloseStatus = () => {
    this.props.getAddonStatus(ANALYTICS_ADDON_NAME);
  };
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  // Get current status addon sync
  getAddonStatus: addonName => dispatch(subscriptionV3Actions.getAddonStatus(addonName)),
  changeValue: (name, value) => dispatch(AnalyticsActions.changeValue(name, value)),
  getDetailInvoice: () => dispatch(subscriptionV3Actions.getDetailInvoice(ownProps.i18n))
});

const mapStateToProps = (state, props) => {
  return {
    statusStore: _.get(state.oauth, 'subscription.status', ''),
    addonLoading: _.get(state.subscriptionV3, 'loading', false),
    addonStatus: _.get(state.subscriptionV3, 'addonStatus', {}),
    notAllowAddon: _.get(state.oauth, 'subscription.notAllowAddon', false),
    invoice: _.get(state.subscriptionV3, 'invoice', {}),
    fromDate: _.get(state.analyticsV2, fromDateStateName),
    toDate: _.get(state.analyticsV2, toDateStateName),
    compare: _.get(state.analyticsV2, compareStateName, false),
    selectedPlan: _.get(state.oauth.tenantApp, 'selectedPlan'),
    featureAnalytics: _.get(state.oauth.tenantApp, 'settings.analyticV2.settings', {})
  };
};

export default withI18n()(connect(mapStateToProps, mapDispatchToProps)(AppInsight));
